/* MANUALLY CHECK WHEN UPDATING THEME
 * Synchronize server-rendered variant panels with Turbo's existing
 * `variant-change` event (emitted by kit-variant-picker-bridge.js).
 */
(() => {
  if (window.gptProductDetailsInitialized) return;
  window.gptProductDetailsInitialized = true;

  const roots = () => document.querySelectorAll('[data-gpt-product-details]');

  // Start Edit: share the product form's decision to activate the rug picker
  const rugForm = root => document.querySelector(
    `.product_form[data-gpt-rug][data-product-id="${root.dataset.gptProductId}"]`
  );
  // End Edit

  // Start Edit: a rug with no selection has no visible Measurements panel
  function showVariant(root, id) {
    const rug = Boolean(rugForm(root));
    if (id == null && !rug) return;

    const wanted = id == null ? '' : String(id).split('/').pop();
    const panels = root.querySelectorAll('[data-gpt-variant]');
    const selected = Array.from(panels).find(panel => panel.dataset.gptVariant === wanted);

    // Never show dimensions for a different size when this one has no specs.
    if (!selected && !rug) return;
    panels.forEach(panel => { panel.hidden = panel !== selected; });

    if (rug) {
      const module = root.querySelector('[data-gpt-variant-panels]')?.closest('.gpt-product-details__module');
      if (module) module.hidden = !selected;
    }
  }
  // End Edit

  // Start Edit: don't substitute the first Size in the absence of a rug variant URL
  function syncFromUrl() {
    const id = new URL(window.location.href).searchParams.get('variant');
    roots().forEach(root => {
      const form = rugForm(root);
      const initial = form ? form.querySelector('kit-variant-picker')?.dataset.variantId : root.dataset.gptInitialVariant;
      showVariant(root, id || initial);
    });
  }
  // End Edit

  // Start Edit: support cleared rug selections in Turbo's existing variant event
  // Match the product ID from Turbo's variant event, independent of section markup.
  document.addEventListener('variant-change', event => {
    const { product, variant } = event.detail || {};
    if (!product) return;

    roots().forEach(root => {
      if (String(product.id).split('/').pop() === root.dataset.gptProductId) {
        showVariant(root, variant?.id);
      }
    });
  });
  // End Edit

  window.addEventListener('popstate', syncFromUrl);
  document.addEventListener('shopify:section:load', syncFromUrl);
  syncFromUrl();
})();
